import { 
  Heart, 
  PartyPopper, 
  Building2, 
  Briefcase, 
  Calendar, 
  Smartphone,
  Camera,
  Baby,
  Sparkles,
  Clock,
  Sunset,
  Plane,
  LucideIcon
} from "lucide-react";

export interface ServiceData {
  icon: LucideIcon;
  title: string;
  slug: string;
  description: string;
  shortDescription: string;
  features: string[];
  image: string;
  category: "personal" | "business" | "celebrations";
  href: string;
}

export const SERVICES_DATA: ServiceData[] = [
  {
    icon: Heart,
    title: "Weddings",
    slug: "weddings",
    description: "Cinematic wedding films that capture every emotion, every glance, and every tear of joy from your special day.",
    shortDescription: "Cinematic wedding films that capture every emotion and moment of your special day.",
    features: ["Full-day coverage", "Highlight film", "Documentary edit", "Raw footage available"],
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?q=40&w=400&auto=format&fit=crop",
    category: "personal",
    href: "/services/weddings",
  },
  {
    icon: Heart,
    title: "Engagement",
    slug: "engagement",
    description: "Celebrate your commitment with a cinematic film capturing the excitement, love, and joy of your engagement.",
    shortDescription: "Celebrate your commitment with a cinematic film capturing the excitement.",
    features: ["Proposal capture", "Ring reveal", "Couple moments", "Celebration coverage"],
    image: "https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?q=40&w=400&auto=format&fit=crop",
    category: "personal",
    href: "/services/engagement",
  },
  {
    icon: Sunset,
    title: "Love Shoot",
    slug: "love-shoot",
    description: "An intimate cinematic experience capturing the magic between you two in stunning locations.",
    shortDescription: "Intimate cinematic experience capturing the magic between you two.",
    features: ["Golden hour shots", "Location of choice", "Romantic storytelling", "Social clips"],
    image: "https://images.unsplash.com/photo-1494774157365-9e04c6720e47?q=40&w=400&auto=format&fit=crop",
    category: "personal",
    href: "/services/love-shoot",
  },
  {
    icon: Clock,
    title: "Anniversary",
    slug: "anniversary",
    description: "Honor your journey together with a cinematic film that captures the depth of your love story.",
    shortDescription: "Honor your journey together with a cinematic love story film.",
    features: ["Couple portraits", "Location shoots", "Interview segments", "Photo montage"],
    image: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?q=40&w=400&auto=format&fit=crop",
    category: "personal",
    href: "/services/anniversary",
  },
  {
    icon: Baby,
    title: "Baby Shower",
    slug: "baby-shower",
    description: "Celebrate the joy of expecting with a cinematic film that captures every smile, surprise, and tender moment.",
    shortDescription: "Celebrate expecting with a film capturing every tender moment.",
    features: ["Gift reveals", "Guest reactions", "Decorative details", "Highlight reel"],
    image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?q=40&w=400&auto=format&fit=crop",
    category: "celebrations",
    href: "/services/baby-shower",
  },
  {
    icon: Sparkles,
    title: "Bridal Shower",
    slug: "bridal-shower",
    description: "An elegant film capturing the joy, laughter, and love shared with the bride before her big day.",
    shortDescription: "Elegant films capturing the joy shared with the bride-to-be.",
    features: ["Party vibes", "Guest messages", "Fun moments", "Stylish coverage"],
    image: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?q=40&w=400&auto=format&fit=crop",
    category: "celebrations",
    href: "/services/bridal-shower",
  },
  {
    icon: PartyPopper,
    title: "Festivals",
    slug: "festivals",
    description: "Dynamic festival coverage capturing the energy, performances, and unforgettable moments of your event.",
    shortDescription: "Dynamic festival coverage capturing the energy and performances.",
    features: ["Artist performances", "Crowd atmosphere", "Behind-the-scenes", "Highlight reels"],
    image: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?q=40&w=400&auto=format&fit=crop",
    category: "business",
    href: "/services/festivals",
  },
  {
    icon: Building2,
    title: "Property",
    slug: "property",
    description: "Stunning property videos that showcase spaces in their best light, helping you sell faster and for more.",
    shortDescription: "Stunning property videos that showcase spaces in their best light.",
    features: ["Cinematic walkthroughs", "Aerial footage", "Agent branding", "Virtual tours"],
    image: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=40&w=400&auto=format&fit=crop",
    category: "business",
    href: "/services/property",
  },
  {
    icon: Briefcase,
    title: "Brands & Business",
    slug: "brands",
    description: "Professional brand films that tell your story, connect with audiences, and elevate your business presence.",
    shortDescription: "Professional brand films that tell your story and connect with audiences.",
    features: ["Brand stories", "Product videos", "Corporate films", "Team profiles"],
    image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?q=40&w=400&auto=format&fit=crop",
    category: "business",
    href: "/services/brands",
  },
  {
    icon: Calendar,
    title: "Events",
    slug: "events",
    description: "Comprehensive event coverage from corporate functions to private celebrations, capturing every key moment.",
    shortDescription: "Comprehensive event coverage from corporate functions to private celebrations.",
    features: ["Conference coverage", "Gala events", "Award ceremonies", "Private parties"],
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=40&w=400&auto=format&fit=crop",
    category: "celebrations",
    href: "/services/events",
  },
  {
    icon: Smartphone,
    title: "Social Media Content",
    slug: "social-media",
    description: "Scroll-stopping content optimized for every platform, designed to engage and grow your audience.",
    shortDescription: "Scroll-stopping content optimized for every platform.",
    features: ["Reels & TikToks", "YouTube content", "Stories & shorts", "Content packages"],
    image: "https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=40&w=400&auto=format&fit=crop",
    category: "business",
    href: "/services/social-media",
  },
  {
    icon: Camera,
    title: "Modelling",
    slug: "modelling",
    description: "Portfolio reels and fashion videography that showcase talent and make a lasting impression on agencies.",
    shortDescription: "Portfolio reels and fashion videography that make an impact.",
    features: ["Portfolio reels", "Fashion campaigns", "Lookbook videos", "Behind-the-scenes"],
    image: "https://images.unsplash.com/photo-1469334031218-e382a71b716b?q=40&w=400&auto=format&fit=crop",
    category: "personal",
    href: "/services/modelling",
  },
  {
    icon: Calendar,
    title: "Live Stream",
    slug: "live-stream",
    description: "Professional multi-camera live streaming for events, conferences, and special occasions broadcast worldwide.",
    shortDescription: "Professional live streaming broadcast worldwide.",
    features: ["Multi-camera setup", "Real-time graphics", "Platform streaming", "Recording included"],
    image: "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?q=40&w=400&auto=format&fit=crop",
    category: "business",
    href: "/services/live-stream",
  },
  {
    icon: Plane,
    title: "Drone",
    slug: "drone",
    description: "Breathtaking aerial cinematography capturing stunning perspectives of your property, event, or brand from above.",
    shortDescription: "Stunning aerial cinematography capturing unique perspectives.",
    features: ["4K aerial footage", "Licensed pilots", "Cinematic shots", "Property flyovers"],
    image: "https://images.unsplash.com/photo-1473968512647-3e447244af8f?q=40&w=400&auto=format&fit=crop",
    category: "business",
    href: "/services/drone",
  },
];

// Derive service types from the services data
export const SERVICE_TYPES = [
  ...SERVICES_DATA.map(s => s.title),
  "Other",
] as const;

export type ServiceType = typeof SERVICE_TYPES[number];

// Service categories for filtering
export const SERVICE_CATEGORIES = [
  { id: "all", label: "All Services" },
  { id: "personal", label: "Personal" },
  { id: "business", label: "Business" },
  { id: "celebrations", label: "Celebrations" },
] as const;

// Helper function to get service by slug
export const getServiceBySlug = (slug: string): ServiceData | undefined => {
  return SERVICES_DATA.find(s => s.slug === slug);
};

// Helper function to get service by title
export const getServiceByTitle = (title: string): ServiceData | undefined => {
  return SERVICES_DATA.find(s => s.title === title);
};
